<template lang="pug">
div.abs-fit
  h1.center.mt4.mb2 请选择项目
  //- div.center.m2(style="position: absolute; top: 0; right: 0;")  
  div.center 
    span 或者
    a-button.ml2(type="primary" size="small" ghost @click="logout") 重新登录
  div.p2(style="margin: 20px auto;")
    div.project-list.project-center(v-if="!!projectCenter")
      ProjectCard.project-item(:project="projectCenter" :isCenter="true")
    div.project-list.pt1
      ProjectCard.project-item.m1(v-for="project in projects" :key="project.id" :project="project")
    //- a-empty(v-if="!projectCenter && !projects.length")
    div.no-projects(v-if="!projectCenter && !projects.length && !loading")
      NoProject
        
</template>

<script>
import NoProject from '@/pages/Error/noproject.vue';

import { getToken, logout } from '@/services/AccountService';
import qs from 'qs';
export default {
  components: {
    NoProject,
    ProjectCard: {
      props: {
        project: Object,
        isCenter: Boolean,
      },
      data() {
        return {};
      },
      computed: {
        imgSrc() {
          let src = '';
          if (this.project.fileDTOS?.length) {
            src = this.$filehost + this.project.fileDTOS[0].path;
          } else {
            src =
              'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png';
          }
          return src;
        },
      },
      methods: {
        async handClickProject(path) {
          const token = await getToken();
          const params = qs.stringify({
            ...token,
            code: this.project.code,
            // cb: this.cb,
          });
          if (this.project.code === 'sncd') {
            // 成都农批 特殊处理!!
            window.name = qs.stringify({
              access_token: window.config.sncd_access_token,
            });
            window.location.href = `${this.project.url}#/xtpt`;
          } else {
            window.location.href = `${this.project.url}#/${path}?${params}`;
          }
        },
      },
      render() {
        return (
          <a-card hoverable>
            <img
              slot="cover"
              alt="example"
              src={this.imgSrc}
              style={{ width: '298px', height: '160px' }}
            />
            {this.isCenter ? (
              <template slot="actions" class="ant-card-actions">
                <a onClick={() => this.handClickProject('xtpt')}>
                  系统管理平台
                </a>
              </template>
            ) : (
              <template slot="actions" class="ant-card-actions">
                <a onClick={() => this.handClickProject('xtpt')}>
                  系统管理平台
                </a>
              </template>
            )}
            <a-card-meta
              title={this.project.name}
              description={
                this.project.introduction ||
                this.project.remark ||
                this.project.name
              }
            >
              <a-avatar slot="avatar" src={this.imgSrc} />
            </a-card-meta>
          </a-card>
        );
      },
    },
  },
  data() {
    return {
      projects: [],
      projectCenter: null,
      loading: false,
    };
  },
  computed: {
    cb() {
      const { cb } = this.$route.query;
      return cb;
    },
  },
  created() {
    this.loadProjects();
  },
  methods: {
    logout,
    async loadProjects() {
      this.loading = true;
      const projects = await this.$restful('GET:/sys/context/user-projects');
      if (projects.length === 1) {
        // 只有一个项目直接跳!
        this.handClickProject(projects[0]);
      }
      this.projectCenter = projects.find((item) => item.code === 'hq');
      this.projects = projects.filter((item) => item.code !== 'hq');
      this.loading = false;
    },
    async handClickProject(prj) {
      // console.log(prj);
      const token = await getToken();
      const params = qs.stringify({
        ...token,
        code: prj.code,
        // cb: this.cb,
      });
      // window.location.href = `${prj.url}#/?${params}`;
      // console.log(`${prj.url}#${this.cb || ''}?${params}`);
      if (prj.url?.includes(location.origin)) {
        // 如果是当前网站
        window.location.href = `${prj.url}#${this.cb || ''}${
          this.cb?.includes('?') ? '&' : '?'
        }${params}`;
        window.location.reload();
      } else {
        // 非本站不带cb, 防止404
        if (prj.code === 'sncd') {
          // 成都农批 特殊处理!!
          window.name = qs.stringify({
            access_token: window.config.sncd_access_token,
          });
          window.location.href = `${prj.url}#/xtpt`;
        } else {
          window.location.href = `${prj.url}#/?${params}`;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.project-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  .project-item {
    width: 300px;
  }
}
</style>
